import React, { Component } from 'react';

//componentes
import Maternal from './maternal'

class Index extends Component {

    render(){
        return(
            <div>
                <Maternal />
            </div>
        );
    }

}
export default Index;